import { useTranslation } from "react-i18next";

import Loading from "@components/shared/Loading";
import Tag from "@components/shared/Tag";
import Card from "@components/zenith/ui/Card";
import Table from "@components/zenith/ui/Table";
import { useSubscriberUsers } from "@hooks/query/zenith/useSubscriberUsers";

const AccountHoldersWidget: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { data, isLoading, isFetching, isError } = useSubscriberUsers({});
  const users = data ?? [];

  const holders = [
    ...users.filter((user: any) => user.isPrimary),
    ...users.filter((user: any) => !user.isPrimary),
  ];

  return (
    <Card title={t("subscriber.accounts_widget_title")} busy={isFetching}>
      {/* A failed refresh keeps the holders last loaded, so only holders that never loaded are unavailable. */}
      {isError && !data ? (
        // Outside the table, whose columns can outgrow a phone, so every word stays on screen.
        <p className="px-5 py-8 text-center text-sm text-gray-500">
          {t("zenith.dashboard.account_holders_unavailable")}
        </p>
      ) : (
        <Table
          aria-label={t("subscriber.accounts_widget_title") as string}
          className="rounded-none border-0"
          columns={[
            {
              key: "name",
              label: t("user.username"),
              render: user => user.name,
            },
            {
              key: "email",
              label: t("user.email"),
              render: user => user.email,
            },
            { key: "tel", label: t("user.tel"), render: user => user.tel },
            {
              key: "type",
              label: t("common.type"),
              render: user => (
                <Tag status={user.isPrimary ? "info" : "warning"}>
                  {user.isPrimary ? t("user.primary") : t("user.general")}
                </Tag>
              ),
            },
          ]}
          rows={holders}
          rowKey={user => user.id}
          empty={isLoading ? <Loading /> : t("common.no_data")}
        />
      )}
    </Card>
  );
};

export default AccountHoldersWidget;
